import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import "../../css/Common/error404.css";

export default function Error404() {
    const navigate = useNavigate();

    return (
        <div className="error404-container">
            {/* CARD */}
            <div className="error404-card">
                <div className="error404-icon">☹</div>

                <h1 className="error404-code">404</h1>

                <p className="error404-text">
                    The page you are attempting to reach is currently not available.
                    This may be because the page does not exist or has been moved.
                </p>

                <Button
                    label="Back To Dashboard"
                    icon="pi pi-home"
                    className="error404-btn"
                    onClick={() => navigate("/dashboard")}
                />
            </div>
        </div>
    );
}
